import React, {useRef} from  'react';
import '../../assets/css/pagination.css'
function PaginationNew(props) {

    const Page = [];
    var pagelimit = props?.size || 12
    if(props.perPage){
        pagelimit = props.perPage
    }
        for(let i=1;i<=Math.ceil(props.number/pagelimit);i++){
            Page.push(i);
    }



    

      function scroll(spcl,com){
        var doc = document.getElementById("ul_page "+com)
        if(spcl === "l"){
            doc.scrollLeft -= 200;
        }
        else{
            doc.scrollLeft += 200;
        }
      }



      if(Math.ceil(props.number/pagelimit)> 5){
        return (
            <div className = "contain-Paginate mb-4">
               
            <nav aria-label="Page navigation example" id="paginationNav">
            {Page.length > 1 ?<p className='ff_pop text-center mb-2 tool_colr'>Showing page {props.activ} of {Math.ceil(props.number/pagelimit)}</p>:<></>}
            {/* <a id="abtn1" >L</a> */}
            <div className='d-flex justify-content-center'>
            <i className="fa fa-chevron-left page-link page_chevrons" id="abtn1" aria-hidden="true" onClick={()=>scroll("l",props.comp)}></i>
                <ul className="ul_page" id={"ul_page "+props.comp}>
            {Page.length>1?
            <>
            
            {
            Page.map((number,index)=>{
            
                    if(index+1 === props.activ){
                        return(
                            // <li className="page-item" onClick={()=>activePage(index)} key={index}>
                            <a className={"page-link mx-1 "+props.comp} id="activePaginationLink" onClick={()=>props.paginate({"number":number,"comp":props.comp})} href="#">{number}</a>
                        // </li>
                        )
                        }
                        else{
                            return(
                                // <li className="page-item" onClick={()=>activePage(index)} key={index}>
                                <a className={"page-link mx-1 "+props.comp} onClick={()=>props.paginate({"number":number,"comp":props.comp})} href="#">{number}</a>
                            // </li>
                            )
                        }
             
            })
        }
          
            </>
            :<>
            </>
               
        }
                </ul>
                <i className="fa fa-chevron-right page-link page_chevrons" id="abtn2" aria-hidden="true" onClick={()=>scroll("r",props.comp)}></i>
            </div>
        
            </nav>
        
            </div>
            
        )
      }
    else{
        return (
            <div className = "contain-Paginate mb-2">
            <nav aria-label="Page navigation example" id="paginationNav">
            {Page.length > 1 ?<p className='ff_pop text-center mb-2 tool_colr'>Showing page {props.activ} of {Math.ceil(props.number/pagelimit)}</p>:<></>}
            <div className='d-flex justify-content-center'>
            {/* <i className="fa fa-chevron-left page-link page_chevrons" id="abtn1" aria-hidden="true"></i> */}
                <ul className="ul_page" id={"ul_page "+props.comp}>
            {Page.length>1?
            <>
            
            {
            Page.map((number,index)=>{
            
                    if(index+1 === props.activ){
                        return(
                            // <li className="page-item" onClick={()=>activePage(index)} key={index}>
                            <a className={"page-link mx-1 "+props.comp} id="activePaginationLink" onClick={()=>props.paginate({"number":number,"comp":props.comp})} href="#">{number}</a>
                        // </li>
                        )
                        }
                        else{
                            return(
                                // <li className="page-item" onClick={()=>activePage(index)} key={index}>
                                <a className={"page-link mx-1 "+props.comp} onClick={()=>props.paginate({"number":number,"comp":props.comp})} href="#">{number}</a>
                            // </li>
                            )
                        }
             
            })
        }
          
            </>
            :<>
            </>
               
        }
                </ul>
                {/* <i className="fa fa-chevron-right page-link page_chevrons" id="abtn2" aria-hidden="true"></i> */}
            </div>
        
            </nav>
        
            </div>
            
        )
    }
   
}

export default PaginationNew;